import { render, staticRenderFns } from "./ManifestDialog.vue?vue&type=template&id=cc288d54&scoped=true"
import script from "./ManifestDialog.vue?vue&type=script&lang=js"
export * from "./ManifestDialog.vue?vue&type=script&lang=js"
import style0 from "./ManifestDialog.vue?vue&type=style&index=0&id=cc288d54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc288d54",
  null
  
)

export default component.exports